import axios from "axios";
import CryptoJS from "crypto-js";
import { responseErrorInterceptor } from "./staff";

export const memberClient = axios.create({
    baseURL: "https://rest.miview.shop",
    // baseURL: "http://localhost:8101",
    withCredentials: true,
});

export namespace MemberApis {
    export const loginViaLine = async (lineCode: string) => {
        try {
            const body = {
                line_code: lineCode
            }
            const ret = await memberClient.post(`/member/line/login`, body);
            console.log("[loginViaLine] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[loginViaLine] error", e);
            throw e;
        }
    }

    export const getMyInfo = async () => {
        try {
            const ret = await memberClient.get(`/member/my-info`);
            console.log("[getMyInfo] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getMyInfo] error", e);
            throw e;
        }
    }

    export const getCounsel = async (counselId) => {
        try {
            const ret = await memberClient.get(`/member/counsels/${counselId}`);
            console.log("[getCounsel] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getCounsel] error", e);
            throw e;
        }
    }

    export const patchCounsel = async (counselId, body) => {
        try {
            const ret = await memberClient.patch(`/member/counsels/${counselId}`, body);
            console.log("[patchCounsel] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[patchCounsel] error", e);
            throw e;
        }
    }

    export const getReviews = async (offset, limit) => {
        try {
            const params = {
                offset,
                limit
            }
            const ret = await memberClient.get(`/member/reviews`, { params });
            console.log("[getReviews] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getReviews] error", e);
            throw e;
        }
    }

    export const getReview = async (reviewId) => {
        try {
            const ret = await memberClient.get(`/member/reviews/${reviewId}`);
            console.log("[getReview] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[getReview] error", e);
            throw e;
        }
    }

    export const createReview = async (body) => {
        try {
            const ret = await memberClient.post(`/member/reviews`, body);
            console.log("[createReview] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[createReview] error", e);
            throw e;
        }
    }

    export const patchReview = async (reviewId, body) => {
        try {
            const ret = await memberClient.patch(`/member/reviews/${reviewId}`, body);
            console.log("[patchReview] ret", ret);
            return ret.data;
        } catch (e) {
            console.error("[patchReview] error", e);
            throw e;
        }
    }
}